import React, { useEffect, useState } from 'react';
import './SearchList.css';
import * as api from 'api.js';
import { useGlobalState } from 'hooks';
import { useHistory } from 'react-router-dom';

function parseSearchList(list) {
    return list.filter((item) => item.Size !== 0 && item.Key.match(/\//g));
}

export function SearchList() {
    const [state, dispatch] = useGlobalState();
    const [apiError, setApiError] = useState('');
    const [origFileList, setOrigFileList] = useState([]);
    const [filteredFileList, setFilteredFileList] = useState([]);
    const [searchString, setSearchString] = useState([]);
    const history = useHistory();

    useEffect(() => {
        dispatch.setBusy(true); //*
        const getFileList = async () => {
            try {
                const fileList = await api.getFileList();
                let parsedSearchFileList = parseSearchList(fileList);
                setOrigFileList(parsedSearchFileList);
                setFilteredFileList(parsedSearchFileList);
            } catch (error) {
                if (error.response) {
                    setApiError(JSON.stringify(error.response));
                }
            } finally {
                dispatch.setBusy(false);
            }
        };
        getFileList(); //*
        /*
        let parsedSearchFileList = parseSearchList(api.fileList_2);
        setOrigFileList(parsedSearchFileList);
        setFilteredFileList(parsedSearchFileList);
        */
    }, []);

    function handleChange(value) {
        setSearchString(value);
        let filteredList = origFileList.filter((file) => {
            let regex = new RegExp(value, 'gi');
            let filenameMatch = file.Key.match(regex);
            let descriptionMatch = null;
            let infoMatch = null;
            if (file.Metadata.description) {
                descriptionMatch = file.Metadata.description.match(regex);
            }
            if (file.Metadata.additional_info) {
                infoMatch = file.Metadata.additional_info.match(regex);
            }

            if (filenameMatch !== null || descriptionMatch !== null || infoMatch !== null) {
                return true;
            }
            return false;
        });
        setFilteredFileList(filteredList);
    }

    function clickHandler(file) {
        let fileSize = file.Size;
        let description = file.Metadata.description ? file.Metadata.description : '';
        let additional_info = file.Metadata.additional_info ? file.Metadata.additional_info : '';
        let modified = file.LastModified;
        let pathString = file.Key;
        let pathArray = pathString.split('/');
        let filename = pathArray.pop();
        dispatch.setRememberSelectedFile(true);
        dispatch.setSelectedFile({
            name: filename,
            size: fileSize,
            modified: modified,
            metadata: { description: description, additional_info: additional_info },
        });
        dispatch.setCurrentPath(pathArray);
        history.push('/transceivers');
    }

    if (apiError) {
        return (
            <>
                <h3>API error:</h3>
                {apiError}
            </>
        );
    }

    return (
        <div className="search_list_main_cont">
            <div className="text_input_cont">
                <input
                    type="text"
                    value={searchString}
                    onChange={(ev) => handleChange(ev.target.value)}
                    placeholder="enter search string"
                />
            </div>
            <div className="search_list_heading">
                <div className="search_list_heading_main">
                    <div className="file_with_path text_center">file</div>
                    <div className="file_size text_center">size</div>
                    <div className="file_description text_center">description</div>
                    <div className="file_additional_info text_center">additional info</div>
                    <div className="search_scrollbar_padding"></div>
                </div>
            </div>
            <div className="search_list_cont">
                {filteredFileList.map((file) => (
                    <SearchListItem key={file.Key} file={file} handleClick={clickHandler} />
                ))}
            </div>
        </div>
    );
}

function SearchListItem({ file, handleClick }) {
    let fileWithPath = file.Key;
    let fileSize = file.Size;
    let description = file.Metadata.description ? file.Metadata.description : '';
    let additional_info = file.Metadata.additional_info ? file.Metadata.additional_info : '';

    return (
        <div className="search_list_item_main" onClick={() => handleClick(file)}>
            <div className="file_with_path">{fileWithPath}</div>
            <div className="file_size">{fileSize}</div>
            <div className="file_description">{description}</div>
            <div className="file_additional_info">{additional_info}</div>
        </div>
    );
}
